<template>
  <button
    :style="{
      width: '100%',
      textAlign: 'left',
      display: 'flex',
      alignItems: 'center',
      gap: '14px',
      padding: '11px 16px',
      cursor: 'pointer',
      fontFamily: 'inherit',
      border: 0,
      borderLeft: `3px solid ${selected ? 'var(--p-primary-500)' : 'transparent'}`,
      borderBottom: '1px solid var(--p-content-border-color)',
      background: selected ? 'var(--p-highlight-background)' : 'transparent',
    }"
    @click="emit('click')"
    @dblclick="emit('dblclick')"
  >
    <span
      :style="{
        fontWeight: 700,
        fontSize: '14px',
        color: 'var(--p-text-color)',
        minWidth: '210px',
        flexShrink: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }"
    >{{ config.primary(record) }}</span>
    <span
      v-if="config.secondary"
      :style="{ fontSize: '12.5px', color: 'var(--p-text-muted-color)', flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }"
    ><RenderNode :node="secondary" /></span>
    <StatusBits :record="record" :field-definitions="fieldDefinitions" :field-meta="fieldMeta" :keys="keys" />
    <i class="pi pi-chevron-right" :style="{ fontSize: '11px', color: 'var(--p-surface-400)', marginLeft: 'auto' }" />
  </button>
</template>

<script setup>
// Compact list row. Ported from collection-frame ListRow. Emits click / dblclick
// (the parent CollectionBody knows the record id).
import { computed } from 'vue'
import StatusBits from './StatusBits.vue'
import RenderNode from '@/admin-collection-layout/lib/RenderNode.js'

const props = defineProps({
  record: { type: Object, required: true },
  config: { type: Object, required: true },
  fieldDefinitions: { type: Object, required: true },
  fieldMeta: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
  cols: { type: Array, default: null },
})
const emit = defineEmits(['click', 'dblclick'])

const keys = computed(() => props.cols || props.config.columns || [])
const secondary = computed(() => (props.config.secondary ? props.config.secondary(props.record) : null))
</script>
